//#region src/drug-codes/constants.ts
/** Capsule and Tablet form codes.
* product configurations with a packageSizeUnit value of EA and
* any of the following form codes are considered "simply quantity package not relevant" */
const CAPSULE_AND_TABLET_FORM_CODES = new Map([
	["C12A", "Capsule"],
	["C24A", "Capsule"],
	["CAPA", "Capsule"],
	["CAPS", "Capsule"],
	["CP12", "Capsule"],
	["CP24", "Capsule"],
	["CPCR", "Capsule"],
	["CPCW", "Capsule"],
	["CPDR", "Capsule"],
	["CPEA", "Capsule"],
	["CPEC", "Capsule"],
	["CPEP", "Capsule"],
	["CPSP", "Capsule"],
	["CS12", "Capsule"],
	["CS24", "Capsule"],
	["CSDR", "Capsule"],
	["CSER", "Capsule"],
	["SUBL", "Tablet"],
	["T12A", "Tablet"],
	["T24A", "Tablet"],
	["TABA", "Tablet"],
	["TABS", "Tablet"],
	["TB12", "Tablet"],
	["TB24", "Tablet"],
	["TB3D", "Tablet"],
	["TB3E", "Tablet"],
	["TBCR", "Tablet"],
	["TBDD", "Tablet"],
	["TBDP", "Tablet"],
	["TBDR", "Tablet"],
	["TBEA", "Tablet"],
	["TBEC", "Tablet"],
	["TBED", "Tablet"],
	["TBEF", "Tablet"],
	["TBSO", "Tablet"],
	["CHER", "Tablet"],
	["CHEW", "Tablet"]
]);
const PACKAGE_CODE = "PA";

//#endregion
export { CAPSULE_AND_TABLET_FORM_CODES, PACKAGE_CODE };